// extracted by mini-css-extract-plugin
module.exports =  {"ratings-container":"ratings-container-eQRLs","icon-container":"icon-container-kow_q","icon":"icon-QwGlD","disabled":"disabled-W7ks1"};